import {gsap} from "gsap";

export class ScreenDarkOverlayView extends PIXI.Container {
    private _overlay: PIXI.Sprite;

    constructor() {
        super();
        this.name = "ScreenDarkOverlay";
        this.createOverlay();
    }

    private _isOverlayVisible: boolean;

    get isOverlayVisible(): boolean {
        return this._isOverlayVisible;
    }

    set isOverlayVisible(value: boolean) {
        this._isOverlayVisible = value;
    }

    public addOverlay(duration: number = 0.05, alphaValue: number = 0.80): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._overlay.alpha = 0;
            this._overlay.visible = true;
            this._overlay.tint = 0x000000;
            this.isOverlayVisible = true;
        });
        tl.to(this._overlay, {duration: duration, alpha: alphaValue});
        return tl;
    }

    public hideOverlay(duration: number = 0.2): gsap.core.Timeline {
        const hideOverlayTl: gsap.core.Timeline = gsap.timeline();
        hideOverlayTl.to(this._overlay, {duration: duration, alpha: 0});
        hideOverlayTl.add(() => {
            this.isOverlayVisible = false;
            this._overlay.visible = false;
        });
        return hideOverlayTl;
    }


    private createOverlay(): void {
        this._overlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._overlay.name = "overlay";
        this._overlay.tint = 0x000000;
        this._overlay.alpha = 0.8;
        this._overlay.visible = false;

        this._overlay.width = 2040;
        this._overlay.height = 2040;
        this._overlay.position.set(360, 360);
        this._overlay.anchor.set(0.5, 0.5);
        this.addChild(this._overlay);
    }

}